var map = {
	"./decidim/avatar-multiuser.png": 1829,
	"./decidim/brands/google.svg": 8120,
	"./decidim/cc-badge.png": 7779,
	"./decidim/decidim-logo.svg": 4183,
	"./decidim/default-avatar.svg": 9179,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 9505,
	"./decidim/icons.svg": 2266,
	"./decidim/pattern.png": 5209,
	"./decidim/placeholder-card-g.svg": 6726,
	"./decidim/placeholder-card-l.svg": 2685,
	"./decidim/placeholder.jpg": 3756,
	"./decidim/remixicon.symbol.svg": 430,
	"./decidim/vendor/leaflet/layers-2x.png": 3323,
	"./decidim/vendor/leaflet/layers.png": 7682,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 9319,
	"./decidim/vendor/leaflet/marker-icon.png": 9070,
	"./decidim/vendor/leaflet/marker-shadow.png": 9813,
	"./decidim/vendor/social-share-button/douban.svg": 913,
	"./decidim/vendor/social-share-button/email.svg": 1266,
	"./decidim/vendor/social-share-button/facebook.svg": 8138,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 2352,
	"./decidim/vendor/social-share-button/hacker_news.svg": 1298,
	"./decidim/vendor/social-share-button/linkedin.svg": 6608,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 4169,
	"./decidim/vendor/social-share-button/pinterest.svg": 2876,
	"./decidim/vendor/social-share-button/reddit.svg": 9350,
	"./decidim/vendor/social-share-button/telegram.svg": 4135,
	"./decidim/vendor/social-share-button/tumblr.svg": 6260,
	"./decidim/vendor/social-share-button/twitter.svg": 6903,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5509,
	"./decidim/vendor/social-share-button/wechat.svg": 3768,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9688,
	"./decidim/vendor/social-share-button/x.svg": 1362,
	"./decidim/vendor/social-share-button/xing.svg": 6262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1952;